"use client";

import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import { usePathname } from "next/navigation";
import { useAuth } from "@/contexts/AuthContext";
import { useOnboarding } from "@/contexts/OnboardingContext";

export default function TourFloatingButton() {
  const pathname = usePathname();
  const { user, isLoading } = useAuth();
  const { openTour, isTourOpen } = useOnboarding();

  if (isLoading || isTourOpen) return null;
  if (pathname?.startsWith("/admin")) return null;

  return (
    <button
      type="button"
      onClick={() =>
        openTour({
          audience: user ? "auth" : "guest",
          source: "floating_help",
        })
      }
      aria-label="Open platform tour"
      title="How Sell It Off works"
      className="fixed right-4 md:right-6 top-20 mt-4 md:top-24 z-[10025] inline-flex h-10 w-10 items-center justify-center rounded-full border border-border bg-surface/95 text-foreground shadow-lg backdrop-blur hover:bg-surface hover:text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
    >
      <QuestionMarkCircleIcon className="h-6 w-6" />
    </button>
  );
}
